import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import { answerStatusSelector } from '../../store/selectors';
import { setAnswerStatus } from '../../store/actions';
import { answerStatuses } from '../../constants/common';
import useFilterChange from '../../hooks/useFilterChange';

const SelectAnswerStatus = ({ className }) => {
  const answerStatus = useSelector(answerStatusSelector);

  const [value, setValue] = useState(answerStatus);

  const change = useFilterChange({ action: setAnswerStatus });

  const handleChange = (value) => {
    setValue(value);
    change(value);
  };

  useEffect(() => {
    setValue(answerStatus);
  }, [answerStatus]);

  return (
    <Select
      className={className}
      placeholder="Статус ответа"
      value={value}
      onChange={handleChange}
      allowClear
    >
      {Object.values(answerStatuses).map((status) => (
        <Select.Option key={status.id} value={status.id}>
          {status.content}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectAnswerStatus;
